import React from "react";
import { NavLink, NavLinkProps } from "react-router-dom";
import { useNavigationBlocker } from "@/context/NavigationBlockerContext";

interface BlockableNavLinkProps extends Omit<NavLinkProps, "onClick"> {
  children: React.ReactNode;
}

const BlockableNavLink = ({ to, children, ...props }: BlockableNavLinkProps) => {
  const { attemptNavigation } = useNavigationBlocker();

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    const path = typeof to === "string" ? to : to.pathname || "";

    if (!attemptNavigation(path)) {
      e.preventDefault();
    }
  };

  return (
    <NavLink to={to} onClick={handleClick} {...props}>
      {children}
    </NavLink>
  );
};

export default BlockableNavLink;
